import React from 'react';
import PropTypes from 'prop-types';
import './pill.css';

const Pill = props => {
  return (
    <span className="btn text-uppercase pill">
      <strong>{props.content}</strong>
    </span>
  );
};

Pill.defaultProps = {};

Pill.propTypes = {
  content: PropTypes.string.isRequired,
};

export default Pill;



// WEBPACK FOOTER //
// ./src/ui/src/component/pill/pill.js